export default __webpack_public_path__ + "static/media/icProfile.9d8899fc.svg";